import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { PriceSuggestionPriceDTO } from '@retail/price-suggestion/types';
import { PriceSuggestionType } from '@retail/products/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface SearchProps {
  assortmentId: number;
  includeOwner: boolean;
  inAssortment?: boolean;
  suggestionTypes?: PriceSuggestionType[];
  mgSupplierIds?: number[];
  discountGroupIds?: string[];
  groupNumbers?: string[];
  query?: string;
}

export function useFetchPriceSuggestionPrices(
  {
    assortmentId,
    includeOwner,
    inAssortment,
    suggestionTypes,
    mgSupplierIds,
    discountGroupIds,
    groupNumbers,
    query,
  }: SearchProps,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<PriceSuggestionPriceDTO[]>({
    method: 'GET',
    queryKey: [
      'price-suggestion-prices',
      assortmentId,
      includeOwner,
      inAssortment,
      suggestionTypes,
      mgSupplierIds,
      discountGroupIds,
      groupNumbers,
      query,
    ],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.priceSuggestion.getFullLinkPath(),
      searchParams: {
        assortmentId,
        includeOwner,
        inAssortment,
        suggestionTypes,
        mgSupplierIds,
        discountGroupIds,
        groupNumbers,
        query,
      },
    }),
    ...queryOptions,
  });
}
